module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "demo-navigation mdl-navigation mdl-color--blue-grey-800"
  }, [_c('a', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "href": ""
    }
  }, [_c('i', {
    staticClass: "mdl-color-text--blue-grey-400 material-icons",
    attrs: {
      "role": "presentation"
    }
  }, [_vm._v("home")]), _vm._v("\n    " + _vm._s(_vm.i18n().home) + "\n  ")]), _vm._v(" "), _c('router-link', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "to": {
        name: 'csv-words'
      }
    }
  }, [_c('i', {
    staticClass: "mdl-color-text--blue-grey-400 material-icons",
    attrs: {
      "role": "presentation"
    }
  }, [_vm._v("search")]), _vm._v("\n    " + _vm._s(_vm.i18n().csvWordsAnalyzer) + "\n  ")]), _vm._v(" "), _c('router-link', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "to": {
        name: 'csv-ads'
      }
    }
  }, [_c('i', {
    staticClass: "mdl-color-text--blue-grey-400 material-icons",
    attrs: {
      "role": "presentation"
    }
  }, [_vm._v("grade")]), _vm._v("\n    " + _vm._s(_vm.i18n().csvAdsAnalyzer) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout-spacer"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "to": {
        name: 'account-settings'
      }
    }
  }, [_c('i', {
    staticClass: "mdl-color-text--blue-grey-400 material-icons",
    attrs: {
      "role": "presentation"
    }
  }, [_vm._v("account_box")]), _vm._v("\n    " + _vm._s(_vm.i18n().accountSettings) + "\n  ")]), _vm._v(" "), _c('router-link', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "to": {
        name: 'logout'
      }
    }
  }, [_c('i', {
    staticClass: "mdl-color-text--blue-grey-400 material-icons",
    attrs: {
      "role": "presentation"
    }
  }, [_vm._v("exit_to_app")]), _vm._v("\n    " + _vm._s(_vm.i18n().logout) + "\n  ")]), _vm._v(" "), _c('a', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "href": ""
    }
  }, [_c('i', {
    staticClass: "mdl-color-text--blue-grey-400 material-icons",
    attrs: {
      "role": "presentation"
    }
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', {
    staticClass: "visuallyhidden"
  }, [_vm._v(_vm._s(_vm.i18n().help))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59e6df1e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LeftMenu.vue
// module id = 449
// module chunks = 0